import Link from 'next/link';

import { type Locale, authHref, route } from '../_lib/marketing-routes';
import { Wordmark } from './wordmark';

/**
 * Reduzierter Header für Ad-Landing-Pages (`/lp/*`, inkl. `/en/lp/*`, `/fr/lp/*`):
 * nur Logo (→ Locale-Home) + ein Primary-CTA „Kostenlos starten". Keine Nav, kein
 * Auth/Login, kein Burger, kein `useUser` – ein einziges Conversion-Ziel.
 * `nav-actions-lp` hält den Knopf auch am Telefon sichtbar (der normale Kopf
 * blendet `.nav-actions` unter 1024 px aus und hat dafür das Burger-Menü).
 * Logo-Markup/CSS-Klassen aus `SiteHeader` wiederverwendet. Server-Component:
 * die Locale kommt als Prop von `MarketingHeader` (kein eigenes `usePathname`).
 */
const COPY: Record<Locale, { brandAria: string; cta: string }> = {
  de: { brandAria: 'Locari Startseite', cta: 'Kostenlos starten' },
  en: { brandAria: 'Locari homepage', cta: 'Start for free' },
  fr: { brandAria: 'Accueil Locari', cta: 'Commencer gratuitement' },
};

export function LpHeader({
  locale = 'de',
  ohneAktion = false,
}: {
  locale?: Locale;
  ohneAktion?: boolean;
}) {
  const c = COPY[locale];

  return (
    <header className="nav" role="banner">
      <div className="nav-inner container">
        <Link
          href={route('home', locale)}
          className="nav-brand"
          aria-label={c.brandAria}
        >
          <Wordmark />
        </Link>

        {ohneAktion ? null : (
          <div className="nav-actions nav-actions-lp">
            <Link
              href={authHref('signUp', locale)}
              className="btn btn-marke"
              data-test="lp-header-cta-signup"
            >
              {c.cta}
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
